import Vuex from 'vuex';
import cartService from 'Assets/js/components/cartService';

const tryGetCartInstance = () => {
  if (!window.cartInstance) {
    window.cartInstance = new Vuex.Store({
      state: {
        instance: cartService.getInstance()
      },
      getters: {
        cartInstance: (state) => state.instance
      }
    });
  }
  return window.cartInstance;
};

const cartInstance = tryGetCartInstance();
export default cartInstance;
